import ArrowsArrowLeftDownLine from './arrows-arrow-left-down-line.component.js'

export * from './arrows-arrow-left-down-line.component.js'
export default ArrowsArrowLeftDownLine

ArrowsArrowLeftDownLine.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-icon-arrow-left-down-line': ArrowsArrowLeftDownLine
  }
}
